import { render, staticRenderFns } from "./StripeTerminal.vue?vue&type=template&id=c65a4280&"
import script from "./StripeTerminal.vue?vue&type=script&lang=js&"
export * from "./StripeTerminal.vue?vue&type=script&lang=js&"
import style0 from "./StripeTerminal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports